import React, { useState, useEffect } from 'react'

import { PetAndServices } from '../../../components/schedulingSteps'
import { ServiceScheduleContextProvider } from '../../../context/serviceScheduleContext'

function PetService (props) {
  const [localStorageAvailable, setLocalStorageAvailable] = useState(false)

  useEffect(() => {
    // Verifica se o localStorage está disponível
    if (typeof localStorage !== 'undefined') {
      setLocalStorageAvailable(true)
    } else {
      setLocalStorageAvailable(false)
    }
  }, [])

  // Renderiza o componente apenas se o localStorage e a categoria de serviços estiverem disponíveis.
  if (!localStorageAvailable && !props?.router?.query?.category) {
    return <div>Aguarde...</div> // TO-DO substituir por loading da cobasi
  }

  return (
    <ServiceScheduleContextProvider>
      <PetAndServices />
    </ServiceScheduleContextProvider>
  )
}

// Optei por usar o hook "useRouter" pois o contexto tem um certo delay
export default PetService
